<template>
  <div class="child-m">
    <div class="f-right return-material-btn-parent"
      v-if="isReturnMaterialsEnabled"
      >
      <div class="text-right return-material-btn-child d-flex">
        <div v-if="showSaveButton && hasMaterials && enableSaveBtnGRN && $hasPermission('update_grn')">
          <Button size="mini" type="secondary" :disabled="disableGrnSave || selectedConsignee.pod_approved" @click="saveGRN" v-if="enableSave">{{$t('SUBMIT_GRN')}}</Button>
          <Spinner v-else style="position: relative;left: 35px;bottom: 6px;"/>
        </div>
        <div v-if="!showSaveButton && orderDetails.status === 23 && showExistingGrnReject">
          <reject-epod :orderDetails="orderDetails" :selectedConsignee="selectedConsignee"
            @epodRejected="$emit('epodRejected')"
            @epodRejectReason="epodRejectReason">
          </reject-epod>
        </div>
        <div v-if="canShowReturnMaterials && hasRemainingMaterials">
          <Spinner v-if="returnMaterialLoader" style="position: relative;bottom: 3px;"/>
          <Button v-else size="mini" :disabled="!showReturnMaterialSave" type="secondary" @click="saveReturnMaterials">
            {{$t('UPDATE_RETURN_MATERIALS')}}
          </Button>
        </div>
      </div>
      <div v-if="canShowReturnMaterials && hasRemainingMaterials" style="position: relative;bottom: 3px;">
        <Checkbox :value="returnAllMaterials" class="text-label text-lowercase" @input="handleReturnMaterials">
          {{$t('MARK_ALL_RETURN')}}
        </Checkbox>
      </div>
    </div>
    <div v-else>
      <div class="flex-item text-right" v-if="showSaveButton && hasMaterials && enableSaveBtnGRN && $hasPermission('update_grn') && !selectedConsignee.pod_approved" >
        <Button size="mini" type="secondary" @click="saveGRN" :disabled="disableGrnSave" v-if="enableSave">{{$t('INDENT_SAVE')}}</Button>
        <Spinner v-else/>
      </div>
      <div class="flex-item text-right ml-auto" v-else-if="!showSaveButton && orderDetails.status === 23 && showExistingGrnReject">
        <reject-epod
          :orderDetails="orderDetails"
          :selectedConsignee="selectedConsignee"
          @epodRejected="$emit('epodRejected')"
          @epodRejectReason="epodRejectReason">
        </reject-epod>
      </div>
    </div>
    <div class="ml-m5 child-mb" v-for="(materials, key, index) in materialsList" v-bind:key="index">
      <div :class="isDivisionGroupingDisabled ? 'pl-10 mt-15' : 'flex-container pl-10 mt-5'">
        <div class="flex-item" v-if="!isDivisionGroupingDisabled">
          <p>
            <span v-if="isGateWiseLrConfig && materials[0].gateName">{{$t('INDENT_GATE')}} :</span>
            <span v-else-if="!isGateWiseLrConfig">{{$t('INDENT_DIVISION')}} :</span>
            <strong class="text-bold">
              <span v-if="isGateWiseLrConfig">{{materials[0].gateName}}</span>
              <span v-else>{{getIndentDivision(key, materials)}}</span>
            </strong>
            <template v-if="getBusinessDivision(materials).length">
              |&nbsp;
              <span>{{$t('INDENT_BUSINESS_DIVISION')}} :</span>
              <strong class="text-bold">
                <span>{{getBusinessDivision(materials).toString()}}</span>
              </strong>
            </template>
          </p>
        </div>
      </div>
      <Collapse
      v-if="hasPackages"
      class="collapse-slider"
      v-model="activeTab">
        <CollapseItem :name="index"
        v-for="(packageDetail,index) in getPackagesList(materials)"
        :key="index">
          <template slot="title">
            <template v-if="packageDetail.isPackage">
              <strong class="mr-10"> {{packageDetail.code}} </strong>
              <template  v-if="packageDetail.reference_id">
                <strong class="mt-m10"> __ </strong>
                <span class="ml-10">{{packageDetail.reference_id}}</span>
              </template>
            </template>
            <template v-else>
              Standalone Materials and Kits
            </template>
            <div v-if="packageDetail.isPackage && canShowGrn" class="d-flex" style="justify-content: end; margin-left: auto; width: -webkit-fill-available;">
              <div @click="preventCollapseAction($event)" class="text-right">
                {{$t('INDENT_PACKAGE_SHORTAGE')}}
                <SwitchBtn
                :value="Boolean(getPackageDetail(packageDetail.id,'is_package_shortage'))"
                label="right"
                  size="small"
                  :disabled="!canEditGrn || selectedConsignee.pod_approved"
                  class="default-switch"
                  @input="changePackageStatus(packageDetail.id,'is_package_shortage', $event)">
                </SwitchBtn>
              </div>
              <div @click="preventCollapseAction($event)" class="text-right ml-15">
                {{$t('INDENT_PACKAGE_DAMAGED')}}
                <SwitchBtn
                :value="Boolean(getPackageDetail(packageDetail.id,'is_package_damaged'))"
                label="right"
                  size="small"
                  :disabled="!canEditGrn || selectedConsignee.pod_approved"
                  class="default-switch"
                  @input="changePackageStatus(packageDetail.id,'is_package_damaged', $event)">
                </SwitchBtn>
              </div>
            </div>
          </template>
          <material-details-table
          :packageDetail="packageDetail"
            :viewAttachmentsDetailsSlider="viewAttachmentsDetailsSlider"
            :materialData="packageDetail"
            :originalMaterialSummaries="allMaterials.original_material_quantities"
            :canShowGrn="canShowGrn"
            :canEditGrn="canEditGrn && !selectedConsignee.pod_approved"
            :canEPODEditAble="canEPODEditAble"
            :editedPackageDetails="editedPackageDetails"
            :unsavedReturnMaterialDetails="unsavedReturnMaterialDetails"
            :canShowReturnMaterials="canShowReturnMaterials"
            :podApproved="selectedConsignee.pod_approved"
            :showDivisionColumn="isDivisionGroupingDisabled"
              @deleteMaterial="deleteMaterial"
              @open-sdlc-categorization="handleSdlcPopup"
              >
          </material-details-table>
        </CollapseItem>
      </Collapse>
      <material-details-table
      v-else
      :viewAttachmentsDetailsSlider="viewAttachmentsDetailsSlider"
        :materialData="{ materials }"
        :originalMaterialSummaries="allMaterials.original_material_quantities"
        :canShowGrn="canShowGrn"
        :canEditGrn="canEditGrn && !selectedConsignee.pod_approved"
        :canEPODEditAble="canEPODEditAble"
        :unsavedReturnMaterialDetails="unsavedReturnMaterialDetails"
        :canShowReturnMaterials="canShowReturnMaterials"
        :podApproved="selectedConsignee.pod_approved"
        :showDivisionColumn="isDivisionGroupingDisabled"
        @deleteMaterial="deleteMaterial"
        @open-sdlc-categorization="handleSdlcPopup"
        >
      </material-details-table>

    </div>
    <SdlcCategorizationPopup
      v-model="sdlcPopupVisible"
      :order-no="sdlcPopupData.orderNo"
      :material="sdlcPopupData.material"
      :movement="orderDetails.movement"
      :order-status="orderDetails.status"
      @saved="handleSdlcSaved"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { has, isEmpty } from 'lodash';
import TableCell from '@/components/orders/documentation/TableCell';
import MaterialDetailsTable from '@/modules-v2/indent/views/document/material-details-table';
import { grnHeaders } from '@common/constants/grnConstants';
import { auditPlatform,
  LorryReceiptGenerationCategory,
  orderDestinationType,
  epodApprovalStatus,
  statusIdDictionary,
} from 'pando-constants';
import RejectEpod from '@/modules-v2/indent/views/document/reject-epod';
import debounce from 'debounce';
import moment from 'moment';
import OrderUtils from '../../../../utils/order';
import SdlcCategorizationPopup from '@/components/orders/documentation/SdlcCategorizationPopup';

export default {
  components: {
    TableCell,
    MaterialDetailsTable,
    RejectEpod,
    SdlcCategorizationPopup,
  },
  props: ['materialsList', 'selectedConsignee', 'viewAttachmentsDetailsSlider',
    'canShowGrn', 'canEditGrn', 'hasMaterialInvoice', 'canEPODEditAble',
    'unsavedReturnMaterialDetails', 'isReturnMaterialsEnabled', 'approve',
    'isDivisionGroupingDisabled'],

  data() {
    return {
      grnHeaders,
      activeTab: [],
      editedPackageDetails: {},
      enableSave: true,
      enableSaveBtnGRN: true,
      returnMaterialLoader: false,
      returnAllMaterials: false,
      sdlcPopupVisible: false,
      sdlcPopupData: {
        orderNo: '',
        material: null,
      },
    };
  },
  async created() {
    if (this.$hasPermission('epod_rejection') && !this.showSaveButton) {
      this.$store.commit('order/SET_CAN_SHOW_SAVE_GRN', false);
      this.canEditGrn = false;
    }
  },
  computed: {
    ...mapGetters({
      orderDetails: 'order/find',
      isOrderLoading: 'order/isOrderLoading',
      configurations: 'app/configurations',
      allMaterials: 'order/materials',
      grnDetails: 'order/grnDetails',
      canShowSaveGrn: 'order/canShowSaveGRN',
    }),
    canShowReturnMaterials() {
      const isAfterDispatched = this.$statusUtil.isAfterDispatched(this.orderDetails.status);
      let isWithinConfiguredDays = true;
      if (this.selectedConsignee.release_at) {
        const deliveredDate = moment(this.selectedConsignee.release_at).startOf('day');
        isWithinConfiguredDays = moment().diff(deliveredDate, 'days') < (this.configurations.return_delivery_creation_window_days || 90);
      }
      return this.isReturnMaterialsEnabled && isAfterDispatched &&
        this.selectedConsignee.type === orderDestinationType.CONSIGNEE && isWithinConfiguredDays;
    },
    hasPackages() {
      return Boolean(this.materialsList &&
        Object.values(this.materialsList)
          .some(materials => materials.some(mat => mat.packages && mat.packages.length)),
      );
    },
    disableGrnSave() {
      if (this.isCleanEpodSaveAllowed) return false;
      return isEmpty(this.grnDetails);
    },

    /**
     * start of material details methods
     */
    isGateWiseLrConfig() {
      return (((this.orderDetails && this.orderDetails.lr_type) ||
        (this.configurations && this.configurations.lorry_receipt_generate_category)) ===
        LorryReceiptGenerationCategory.GATE_WISE
      );
    },
    hasMaterials() {
      return !!Object.keys(this.materialsList).length;
    },
    /**
     * end of material details methods
     */

    /**
     * start of epod details
     */
    inboundShowEditGRN() {
      // currently assuming one source
      if (this.category == 1) {
        // condition for inbound
        if (this.orderDetails.status === 23 || this.orderDetails.status === 6) {
          // inbound we show GRN in Delpending and dispatched
          return true;
        }
      }
      return false;
    },
    /**
     * end of epod details
     */
    isInbound() {
      return this.category === 1;
      // return this.orderDetails.destinations.some(destination =>
      //   destination.location_id === this.filter.depot_id);
    },
    showSaveButton() {
      const destinations = this.orderDetails && this.orderDetails.destinations;
      let dropIndex;
      if (this.selectedConsignee.gate_id) {
        dropIndex = (destinations).map((destination, index) =>
          ((destination.gate_id === this.selectedConsignee.gate_id) ? index : undefined)).filter(x => x >= 0)[0];
      } else {
        dropIndex = (destinations).map((destination, index) =>
          ((destination.location_id === this.selectedConsignee.location_id) ? index : undefined)).filter(x => x >= 0)[0];
      }
      if ((destinations[dropIndex] && destinations[dropIndex].grn_submitted_by && destinations[dropIndex].grn_submitted_by.entity_type) === auditPlatform.TRANSPORTER &&
        this.$hasPermission('epod_rejection')) {
        this.canEditGrn = false;
      }
      // based on approval status we will override all existing grn editability check
      this.canEditGrn = OrderUtils.grnEditabilityCheckBasedOnApprovalStatus(
        this.orderDetails,
        this.canEditGrn,
      );
      return this.canEditGrn;
    },
    isCleanEpodSaveAllowed() {
      if (!this.orderDetails.is_clean_epod_applicable) return false;
      const consigneeMaterials = this.allMaterials && this.allMaterials.materials &&
        this.allMaterials.materials.filter(m =>
          m.destination_location_id === this.selectedConsignee.location_id);
      return OrderUtils.hasZeroSDC(consigneeMaterials);
    },
    showReturnMaterialSave() {
      return !isEmpty(this.unsavedReturnMaterialDetails);
    },
    hasRemainingMaterials() {
      if (this.allMaterials && this.allMaterials.materials) {
        return this.allMaterials.materials.find(material =>
          material.destination_location_id === this.selectedConsignee.location_id &&
          (material.quantity.value - (material.epod.shortage_count || 0) - (material.return_count || 0)) > 0);
      }
      return false;
    },
    showExistingGrnReject() {
      return this.orderDetails.epod_approval_status === epodApprovalStatus.PENDING;
    },
  },
  watch: {
    grnDetails(val) {
      if (!isEmpty(val)) this.enableSaveBtnGRN = true;
    },
  },
  methods: {
    handleSdlcPopup({ material, orderNo }) {
      this.sdlcPopupData = {
        material,
        orderNo,
      };
      this.$nextTick(() => {
        this.sdlcPopupVisible = true;
      });
    },
    handleSdlcSaved() {
      this.sdlcPopupVisible = false;
      this.$emit('sdlc-saved');
    },
    getIndentDivision(key, materials) {
      let result = key && key.split('^')[0];
      if (this.$hasFeature('primary_legal_entity') && result && materials[0].clientLe) {
        result += ` - ${materials[0].clientLe}`;
      }
      return result;
    },
    preventCollapseAction($event) {
      $event.stopPropagation();
    },
    getBusinessDivision(materials) {
      return materials.reduce((acc, material) => {
        if (material.business_division && !acc.includes(material.business_division)) {
          if (material.business_division.trim()) {
            acc.push(material.business_division);
          }
        }
        return acc;
      }, []);
    },
    handleReturnMaterials($event) {
      this.returnAllMaterials = $event;
      if ($event) {
        this.$store.commit('order/UPDATE_RETURN_MATERIALS', this.getReturnAllMaterials());
      } else {
        this.$store.commit('order/UPDATE_RETURN_MATERIALS', {});
      }
    },
    getReturnAllMaterials() {
      return this.allMaterials.materials.reduce((acc, material) => {
        const returnMaterials = material.quantity.value - (material.epod.shortage_count || 0) - (material.return_count || 0);
        if (material.destination_location_id === this.selectedConsignee.location_id && returnMaterials > 0) {
          acc[material.id] = returnMaterials;
        }
        return acc;
      }, {});
    },
    constructReturnMaterialPayload() {
      let destinationLocationId = null;
      const destinationGateIds = this.allMaterials.materials.reduce((acc, material) => {
        if (this.unsavedReturnMaterialDetails[material.id]) {
          acc.add(material.source_gate_id);
          destinationLocationId = material.source_location_id;
        }
        return acc;
      }, new Set());
      const returnMaterials = Object.entries(this.unsavedReturnMaterialDetails).map(keyVal => ({
        material_id: keyVal[0],
        return_count: Number(keyVal[1]),
      }));
      return {
        destination_location_id: destinationLocationId,
        destination_gate_ids: [...destinationGateIds],
        return_materials: returnMaterials,
      };
    },
    clearReturnMaterialData() {
      if (this.isReturnMaterialsEnabled) {
        this.returnAllMaterials = false;
        this.$store.commit('order/UPDATE_RETURN_MATERIALS', {});
        this.$store.commit('order/RETURN_MATERIALS_WARNED_ONCE', false);
      }
    },
    async saveReturnMaterials() {
      this.returnMaterialLoader = true;
      const data = this.constructReturnMaterialPayload();
      const orderNo = this.orderDetails.order_number;
      const consigneeId = this.selectedConsignee.location_id;
      const result = await this.$store.dispatch('order/saveReturnMaterials', { data, orderNo, consigneeId });
      if (result.data) {
        this.$successMessage({ message: this.$t('RETURN_DELIVERIES_CREATION_SUCCESS') });
        this.clearReturnMaterialData();
      } else if (result.error) {
        this.$errorMessage({ message: result.error });
      } else {
        this.$errorMessage({ message: this.$t('RETURN_DELIVERIES_CREATION_FAILED') });
      }
      this.returnMaterialLoader = false;
    },
    epodRejectReason(reason) {
      this.$emit('epodRejectReason', reason);
    },
    getPackageDetail(packageId, key) {
      if (this.editedPackageDetails[packageId] &&
        has(this.editedPackageDetails[packageId], [key])) {
        return this.editedPackageDetails[packageId][key];
      }
      return (this.allMaterials.packages && this.allMaterials.packages[packageId] &&
        this.allMaterials.packages[packageId][key]);
    },
    getAllMaterialsByPackageId(packageId) {
      return this.allMaterials.materials
        .filter(material => material.packages &&
          material.packages.some(val => val.id === packageId));
    },
    getPackagesList(materials) {
      const acc = {};
      materials.forEach((material) => {
        if (material.packages && material.packages.length) {
          material.packages.forEach((matPack) => {
            if (!acc[matPack.id]) {
              acc[matPack.id] = Object.assign({
                id: matPack.id,
                code: matPack.code,
                reference_id: matPack.reference_id,
                isPackage: true,
              }, this.allMaterials.packages[matPack.id]);
            }
            if (acc[matPack.id].materials) {
              acc[matPack.id].materials.push(material);
            } else {
              acc[matPack.id].materials = [material];
            }
          });
        } else if (acc.standalone) {
          acc.standalone.materials.push(material);
        } else {
          acc.standalone = { materials: [material] };
        }
      });
      return acc;
    },
    changePackageStatus(packageId, key, value) {
      const obj = {};
      obj[key] = value;
      if (value) {
        if (key === 'is_package_shortage') {
          obj.is_package_damaged = false;
          this.resetMaterials(packageId);
        }
        if (key === 'is_package_damaged') {
          obj.is_package_shortage = false;
          this.resetMaterials(packageId);
        }
      } else {
        this.resetMaterials(packageId);
      }
      if (this.editedPackageDetails[packageId]) {
        this.editedPackageDetails[packageId] = Object.assign(this.editedPackageDetails[packageId], obj);
      } else {
        const newObj = {};
        newObj[packageId] = obj;
        this.editedPackageDetails = Object.assign(this.editedPackageDetails, newObj);
      }

      this.editedPackageDetails = { ...this.editedPackageDetails };
      if (key === 'is_package_damaged' && value) {
        const materialsList = this.getAllMaterialsByPackageId(packageId);
        this.addMaterialsdamage(materialsList);
      }
      if (key === 'is_package_shortage' && value) {
        const materialsList = this.getAllMaterialsByPackageId(packageId);
        this.addMaterialsShortage(materialsList);
      }
    },
    resetMaterials(packageId) {
      const materialsList = this.getAllMaterialsByPackageId(packageId);
      const grnDetails = Object.assign({}, this.grnDetails);
      let resultObj = {};
      materialsList.forEach((material) => {
        resultObj[material.id] = Object.assign({ id: material.id }, material.epod,
          {
            shortage_count: 0,
            damage_count: 0,
          });
      });
      resultObj = Object.assign({}, grnDetails, resultObj);
      this.$store.commit('order/ADD_ALL_GRN_DETAIL', resultObj);
    },
    addMaterialsShortage(materialsList) {
      const grnDetails = Object.assign({}, this.grnDetails);
      let resultObj = {};
      materialsList.forEach((material) => {
        resultObj[material.id] = Object.assign({ id: material.id }, material.epod,
          {
            shortage_count: material.quantity.value,
            damage_count: 0,
          });
        delete resultObj[material.id].is_submited;
      });
      resultObj = Object.assign({}, grnDetails, resultObj);
      this.$store.commit('order/ADD_ALL_GRN_DETAIL', resultObj);
    },
    addMaterialsdamage(materialsList) {
      const grnDetails = Object.assign({}, this.grnDetails);
      let resultObj = {};
      materialsList.forEach((material) => {
        resultObj[material.id] = Object.assign({ id: material.id }, material.epod, {
          damage_count: material.quantity.value,
          shortage_count: 0,
        });
        delete resultObj[material.id].is_submited;
      });
      resultObj = Object.assign({}, grnDetails, resultObj);
      this.$store.commit('order/ADD_ALL_GRN_DETAIL', resultObj);
    },
    getPackagesEditedData() {
      const result = [];
      Object.entries(this.editedPackageDetails).forEach(([id, data]) => {
        const obj = data;
        obj.id = id;
        result.push(obj);
      });
      return result;
    },
    getCleanEpodMaterials() {
      const consigneeMaterials = this.allMaterials && this.allMaterials.materials &&
        this.allMaterials.materials.filter(m =>
          m.destination_location_id === this.selectedConsignee.location_id);
      if (!consigneeMaterials || !consigneeMaterials.length) return [];
      return consigneeMaterials.map(m => ({
        id: m.id,
        shortage_count: 0,
        damage_count: 0,
        carton_damage_count: 0,
        leakage_count: 0,
        excess_count: 0,
        hold_count: 0,
        actual_qty_received: 0,
      }));
    },
    saveGRN: debounce(async function () {
      this.enableSave = false;
      this.$store.commit('order/SET_CAN_SHOW_SAVE_GRN', false);
      this.$store.commit('order/HAS_USER_EDITED', false);
      this.$store.commit('order/HAS_WARNED_ONCE', false);
      this.$addGAEvent('Indent Management', 'Click', 'Documents:Save button');
      const orderNo = this.orderDetails.order_number;
      const details = this.grnDetails;
      const keys = Object.keys(details);
      const data = [];
      keys.forEach((key) => {
        data.push(details[key]);
      });
      if (!data.length && this.isCleanEpodSaveAllowed) {
        data.push(...this.getCleanEpodMaterials());
      }
      const packages = this.getPackagesEditedData();
      const materials = { materials: data };
      const consigneeId = this.selectedConsignee.location_id;
      try {
        const result = await this.$store.dispatch('order/saveGrn', {
          orderNo,
          mat: materials,
          consigneeId,
          inbound: this.isInbound,
          packages,
        });
        if (result.error || result.error === '') {
          this.$error({ message: result.error || this.$getErr('GRN_SAVE_FAILED') });
        } else if (result) {
          this.$store.commit('order/CLEAR_GRN_DETAIL', []);
          this.clearReturnMaterialData();
          let successMessage = `${this.$getSuccess('GRN_SAVE_SUCCESS')} ${this.getTotalEpod()}`;
          if (result.data) {
            if (result.data.epodSentForApproval) {
              successMessage = `${this.$getSuccess('GRN_SENT_FOR_APPROVAL')}. ${this.getTotalEpod()}`;
            } else if (result.data.epodAutoApproved) {
              successMessage = `${this.$getSuccess('GRN_AUTO_APPROVED')}. ${this.getTotalEpod()}`;
            }
          }
          this.$success({ message: successMessage });
        }
        const orderDetails = await this.$store.dispatch('order/find', orderNo);
        if (this.$statusUtil.isDelivered(orderDetails.status) || this.isCleanEpodSaveAllowed) {
          this.enableSaveBtnGRN = false;
          this.enableSave = false;
        } else {
          this.enableSave = true;
        }
      } catch (err) {
        this.$error({ message: this.$getErr('GRN_SAVE_FAILED') });
      }
    }, 100),
    getTotalEpod() {
      const result = {
        shortage: 0,
        damage: 0,
      };
      Object.values(this.materialsList).forEach((materialsList) => {
        materialsList.forEach((material) => {
          result.shortage += material.shortage_count;
          result.damage += material.damage_count;
        });
      });
      return `Total shortage: ${result.shortage || 0} Total damage: ${result.damage || 0}`;
    },
    async deleteMaterial(material) {
      const orderId = this.orderDetails.order_number;
      const childMaterialId = (material.children && material.children.map(childMat => childMat.id))
        || [];
      const materials = {
        consignee_id: this.selectedConsignee.location_id,
        ids: [material.id, ...childMaterialId],
        unknown_ids: [],
      };
      try {
        await this.$store.dispatch('order/deleteMaterials', { orderId, materials });
        this.$emit('fetchMaterials');
        if (this.configurations && this.configurations.manual_lr === true
          && this.configurations.lorry_receipt_generate_category
          && this.configurations.lorry_receipt_generate_category === LorryReceiptGenerationCategory.CONSIGNEE_WISE
        ) {
          const materialDetails = {
            consignee_id: this.selectedConsignee.location_id,
            consignee_gate_id: this.selectedConsignee.gate_id ? this.selectedConsignee.gate_id : null,
            invoiceNo: material.invoice.number,
          };
          await this.$store.dispatch('order/deleteMaterialInvoiceLR',
            { orderId, materialDetails });
        }
        this.$success({ message: 'Material Deleted.' });
      } catch (err) {
        this.$errorMessage({ message: 'Material delete failed. Please try after some time!' });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.return-material-btn-parent {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-around;
  align-items: flex-end;
  position: relative;
  top: 10px;
}
.return-material-btn-child:not(:last-child)  {
  display: flex;
  justify-content: space-around;
  width: 100%;
  position: relative;
  // left: 12px;
  top: 2px;
}
.spinner {
  position: absolute;
  right: 10px;
  width: 30px !important;
  height: 30px !important;
}

</style>
